import React from "react";
import PropTypes from "prop-types";

import "./data-card.m.css";

export const DataCard = ({ name = "test", value, unit = "", color = false }) => {
  let valueColor = "black";

  if (color && value) {
    valueColor = parseFloat(value) > 0 ? "rgb(var(--green))" : "rgb(var(--alert))";
  }

  return (
    <div styleName="card">
      <div styleName="label">
        <div styleName="name">{name}</div>
      </div>
      <div styleName="value-unit">
        <div styleName="value" style={{ color: valueColor }}>
          {value ? value : "-"}
        </div>
        <div styleName="unit">{unit}</div>
      </div>
    </div>
  );
};

DataCard.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  unit: PropTypes.string,
  color: PropTypes.bool,
};
